module.exports = __webpack_public_path__ + "static/media/mercedes_01.003a5813.png";